import React, { useEffect } from 'react';
import questions from '../../atoms/question';
import gsap from 'gsap';
import './Faq.scss';
import Qlist from '../../atoms/Qlist';

function Faq() {
  useEffect(() => {
    let tl = gsap.timeline({
      ease: 'power0',
      scrollTrigger: {
        trigger: '.faq article',
        start: 'top 75%',
        end: 'bottom 25%',
        toggleActions: 'play none  reverse',
      },
    });

    tl.from('.faq h1', {
      y: '-14vw',
      duration: 1,
    });
  }, []);

  return (
    <section className="faq">
      <div className="box">
        <h1>
          FAQ <hr />
        </h1>
      </div>

      {questions.map((q) => {
        return (
          <article>
            <Qlist {...q} />
          </article>
        );
      })}
    </section>
  );
}

export default Faq;
